<script setup>
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

const props = defineProps({
  source: { type: Object, required: true },
  recommended: { type: Boolean, default: false },
});

const emit = defineEmits(['select']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <button type="button" class="sport-live-tv-stream-option" @click="emit('select', props.source.epgId)">
    <span class="sport-live-tv-stream-option__text">
      <span class="sport-live-tv-stream-option__name">{{ source.name }}</span>
      <span class="sport-live-tv-stream-option__server">{{ source.sourceServerName }}</span>
    </span>
    <span v-if="recommended" class="sport-live-tv-stream-option__recommended">{{ t('recommendedStream') }}</span>
  </button>
</template>

<style lang="scss" scoped>
.sport-live-tv-stream-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border: 0;
  border-radius: 8px;
  background: none;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: $black50;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  &__name,
  &__server {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__name {
    color: $white;
    font-size: 14px;
    font-weight: 600;
  }

  &__server {
    color: $gray;
    font-size: 13px;
  }

  &__recommended {
    flex-shrink: 0;
    padding: 4px 8px;
    border-radius: 6px;
    background-color: $black30;
    color: $bg-red;
    font-size: 13px;
    font-weight: 600;
  }
}
</style>
